/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import { updateSearchResults } from '../../../Redux/SearchEngine/actions';

const SearchPagination = ({ search, updateSearchResults }) => {

    const pageCount = Math.ceil(search?.count / 10);
    const DATA = search?.results || [];

	const gotoPage = (page) => {
		updateSearchResults({ page });
	};

  return (
    <div className="column is-centered">
    {DATA?.length > 0 && (
        <nav
            className="pagination map-pagination is-centered is-rounded mt-4 mb-6"
            role="navigation"
            aria-label="pagination"
        >
            {search?.previous !== null && (
                <a
                    className="pagination-previous"
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        gotoPage(search?.previous);
                    }}
                >
                    Previous
                </a>
            )}
            {search?.next !== null && (
                <a
                    className="pagination-next"
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        gotoPage(search?.next);
                    }}
                >
                    Next
                </a>
            )}

            <ul className="pagination-list">
                {
                    [...Array(pageCount || 0).keys()]
                    .map((i) => {
                        return (
                            <li>
                                <a
                                    className={`pagination-link ${
                                        search.current === i + 1 ? "is-current" : ""
                                    }`}
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        gotoPage(i + 1);
                                    }}
                                >
                                    {i + 1}
                                </a>
                            </li>
                        );
                    })}
            </ul>
        </nav>
    )}
    </div>
  )
}




const mapStateToProps = ({ search }) => {
	return { search };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSearchResults: (e) => dispatch(updateSearchResults(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPagination);
